import styled, { css } from 'styled-components';

import creditAnalysis from '~assets/credit-analysis.svg';
import { BANNER_SPACE_PERCENTAGE } from '../../components/dumbs/Layout/constants';

type IProps = {
  displayBanner: boolean;
};

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.km16};
  width: auto;

  .img-credit-analysis {
    svg {
      display: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};

    .img-credit-analysis {
      svg {
        display: block;
        width: 312px;
        height: 156px;
      }
    }
  }
`;

export const WrapperContent = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  padding-top: ${({ theme }) => theme.spacing.km12};
  padding-right: ${({ theme }) => theme.spacing.km12};
  padding-bottom: ${({ theme }) => theme.spacing.km6};
  padding-left: ${({ theme }) => theme.spacing.km12};

  ${({ displayBanner }) =>
    displayBanner &&
    css`
      margin-right: ${BANNER_SPACE_PERCENTAGE};
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km6};
    margin-right: ${({ theme }) => theme.spacing.km0};
    margin-left: ${({ theme }) => theme.spacing.km0};
  }
`;

export const RightSide = styled.aside`
  position: fixed;
  background: url(${creditAnalysis}) no-repeat;
  background-size: cover;
  background-position: center;
  width: ${BANNER_SPACE_PERCENTAGE};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: ${({ theme }) => theme.spacing.km14};
  padding-top: ${({ theme }) => theme.spacing.km14};
  height: 100%;
  right: 0;
  text-align: end;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: none;
  }
`;

export const Footer = styled.footer`
  align-items: center;
  background: ${({ theme }) => theme.color.background.neutral.default};
  bottom: ${({ theme }) => theme.spacing.km0};
  display: flex;
  gap: ${({ theme }) => theme.spacing.km16};
  height: 96px;
  justify-content: end;
  left: ${({ theme }) => theme.spacing.km0};
  padding-block: ${({ theme }) => theme.spacing.km6};
  padding-inline: ${({ theme }) => theme.spacing.km12};
  position: fixed;
  right: 50%;
  border-top: 1px solid ${({ theme }) => theme.color.border.neutral.default};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    right: 0;
    flex-direction: row;
    justify-content: space-evenly;
  }
`;

export const Highlight = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.bold} !important;
  font-size: ${({ theme }) => theme.font.size.m5};
`;
